'use strict'

import React from 'react';
import ReactDOM from 'react-dom';

// import {Dyn} from '../lib/dynDataSet/dynMiscellany';
// import mediator from '../lib/dynDataSet/mediatorUtil';
import SplitPane from 'react-split-pane';
import Jed from 'jed';
// import WindowMoveLocker from '../components/draggable/WindowMoveLocker';

// CSS
import '../scss/style.scss';

import keymap from '../utils/keymap'
import PropTypes from 'prop-types';
import { Shortcuts, ShortcutManager } from 'react-shortcuts'

import { initDyn } from '../lib/dynDataSet/dynMiscellany';

import PlotStateUtil from '../utils/PlotStateUtil';

import { Validator } from 'jsonschema';
import plotStateSchema from '../utils/plotStateSchema';
import ElemPlayContainer from '../lib/dynElemPlay/ElemPlayContainer';

// load Nerdamer math library and all optional modules
// import nerdamer from'nerdamer/nerdamer.core.js'
// import 'nerdamer/Algebra.js'
// import 'nerdamer/Calculus.js'
// import 'nerdamer/Solve.js'

/*
import '../lib/raphael-extensions/inline_text_editing';
import '../lib/raphael-extensions/line';

import '../lib/dynDataSet/dynMiscellany.js';
import '../lib/dynDataSet/dataSet.js';
import '../lib/dynDataSet/attribute.js';
import '../lib/dynDataSet/formula.js';
import '../lib/dynDataSet/mathUtil.js';
import '../lib/dynDataSet/dataUtil.js';
import '../lib/dynDataSet/colorUtil.js';

import '../lib/dynplot/plotUtil.js';
import '../lib/dynplot/marginView.js';
import '../lib/dynplot/axisUtil.js';
import '../lib/dynplot/axisView.js';
import '../lib/dynplot/plotElement/plotElement.js';
import '../lib/dynplot/plotElement/dotPlotElement.js';
import '../lib/dynplot/plotElement/boxPlotElement.js';
import '../lib/dynplot/plotElement/pieElement.js';
import '../lib/dynplot/plotElement/barElement.js';
import '../lib/dynplot/plotShaper.js';
import '../lib/dynplot/plotMeasures.js';
import '../lib/dynplot/sampleStats.js';
import '../lib/dynplot/iconStyler.js';
import '../lib/dynplot/plotElement/averageElement.js';
import '../lib/dynplot/plotElement/refLineElement.js';
import '../lib/dynplot/plotElement/leastSquaresElement.js';
import '../lib/dynplot/plotElement/plotFunctionElement.js';
import '../lib/dynplot/plotElement/annotateElement.js';
import '../lib/dynplot/plotElement/mapElement.js';
import '../lib/dynplot/plotElement/countElement.js';
import '../lib/dynplot/plotElement/gridLinesElement.js';
import '../lib/dynplot/progressIndicator.js';
import '../lib/dynplot/plotView.js';
import '../lib/dynplot/toolTip.js';
import '../lib/dynplot/dragHandler.js';
*/

import CaseCardComponent from "../components/CaseCardComponent.jsx";
import ToolbarComponent from "../components/ToolbarComponent.jsx";
import CaseTableComponent from "../components/CaseTableComponent.jsx";
import SummaryViewComponent from "../components/SummaryViewComponent.jsx";
import SampleStatsComponent from "../components/SampleStatsComponent.jsx";
import PlotViewLoadingComponent from "../components/loading/PlotViewLoadingComponent.jsx";
import PlainButton from '../components/common/PlainButton';
import KeyboardShortcutsPopup from '../components/KeyboardShortcutsPopup.jsx';
// import CaseTableUtil from "../utils/CaseTableUtil";
import ToolTip from '../components/common/ToolTip';
import "react-toggle/style.css";

import Screenshot from '../components/screenshot/Screenshot';

import '../../font-icons/tde.font';

import ElemPlay from '../components/elem-play/ElemPlay';
import { getColorContrastsByMode, requireJrMode } from '../utils/Util';
import { captureElemPlayView } from '../utils/ScreenshotUtil';

// po files loaded by po2json module
var locale = {
    "ar-SD": require("../locale/ar-SD.po"),
    "es": require("../locale/es.po"),
    "de": require("../locale/de.po"),
    "fr": require("../locale/fr.po"),
    "cantonese": require("../locale/cantonese.po"),
    "mandarin": require("../locale/mandarin.po"),
    "ko": require("../locale/ko.po"),
    "lt": require("../locale/lt.po"),
    "tr": require("../locale/tr.po"),
    "pt": require("../locale/pt.po"),
};

const shortcutManager = new ShortcutManager(keymap);

// To define _gaq in case if it not defined globally
window._gaq = (typeof _gaq != 'undefined') ? _gaq : [];

const ABOUT = require("../../about.json");

const Constants = {
    TABLE_VIEW: 'TABLE',
    SUMMARY_VIEW: 'SUMMARY',
    SAMPLE_STAT_VIEW: 'SAMPLE',
    TABLE_HEADER_HEIGHT: 38, // in px
    TABLE_DEFAULT_OPENING_HEIGHT: 200, // in px
    PLAY_CARD_WIDTH: 280,
    PLAY_CARD_REDUCED: 200, // for reduceCaseCardWidth:true
}

class TuvaDataTool extends React.Component {

    static childContextTypes = {
        shortcuts: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);
        // To create new Dyn object
        this.Dyn = initDyn();

        this.isTouchDevice = this.Dyn.environment.isTouchDevice()
        // assign the user action callback
        if (typeof this.props.onUserAction === "function") {
            this.Dyn.onUserAction = this.props.onUserAction;
        }
        // Listeners to update case table view
        // this.setupListenerForCaseTable();
    }

    state = {
        activeTableView: Constants.TABLE_VIEW,
        resizerSize: Constants.TABLE_HEADER_HEIGHT,
        sampleMode: { isSampleMode:false, selectedView:'' },
        columns: [],
        showKeyboardShortcuts : false,
        fullTableView: 0,
        isPlayViewOn: false
    }

    /*
    componentWillReceiveProps = (nextProps) => {
        if(nextProps.theme && this.props.theme !== nextProps.theme) {
            this.switchTheme(nextProps.theme);
        }
        if(this.props !== nextProps) {
            this.props= nextProps;
            // To update mode
            this.state.mode = this.props.mode;
            // To update language
            this.state.language = this.props.language;
            this.initDataPlot();
        }
    }
    */

    _handleShortcuts = (action, event) => {
        let caseCard = this.refs.caseCardComponent;
        let toolBar = this.refs.toolBar;
        let summaryView = this.refs.summaryViewComponent;
        let Dyn = this.Dyn;


        switch (action) {
            case 'ESCAPE':
                this.chartAreaDiv.focus();
                break;
            case 'CASECARD_FOCUS':
                caseCard.setFocus();
                break;
            case 'TOOLBAR_FOCUS':
                toolBar.setFocus();
                break;
            case 'PLOTVIEW_FOCUS':
                Dyn.plotView.setFocus();
                break;
            case 'TABLEVIEW_FOCUS':
                // TODO: should probably get focus instead of activation
                this._toggleTableView(Constants.TABLE_VIEW);
                break;
            case 'SUMMARYVIEW_FOCUS':
                // TODO: should probably get focus instead of activation
                this._toggleTableView(Constants.SUMMARY_VIEW);
                break;
            case 'TABLE_FULL_VIEW':
                this._toggleTableFullView();
                break;
            case 'SEARCH_ATTRIBUTE':
                //TODO: need to add the logic
                break;
            case 'RESET':   //command+r
                toolBar.handleMenuItemClick(event, {value: 'Mixup'},1);
                break;
            case 'UNDO':    //command+z
                toolBar.handleMenuItemClick(event, {value: 'undo'});
                break;
            case 'REDO':    //command+y
                toolBar.handleMenuItemClick(event, {value: 'redo'});
                break;
            case 'COPY':    //command+c
                toolBar.handleMenuItemClick(event, {value: 'copy'});
                break;
            case 'PASTE':   //command+v
                // Let the window paste event handler handles this event
                // toolBar.handleMenuItemClick(event, {value: 'paste'});
                break;
            case 'DOT':     //command+d
                toolBar.handleMenuItemClick(event, {value: 'Dot',level: 1}, 1)
                break;
            case 'LINE':    //command+l
                toolBar.handleMenuItemClick(event, {value: 'Line',level: 1}, 1)
                break;
            case 'LINE_CATEGORY':   //command+l+c
                toolBar.handleMenuItemClick(event, {value: 'LineAndCategory',level: 1}, 1);
                break;
            case 'PIE':     //command+e
                toolBar.handleMenuItemClick(event, {value: 'Pie',level: 1}, 1);
                break;
            case 'BAR_FREQUENCY':     //command+b
                toolBar.handleMenuItemClick(event, {value: 'BarChartOfFreq',level: 1}, 1);
                break;
            case 'BAR_VALUE':     //command+b
                toolBar.handleMenuItemClick(event, {value: 'BarChartOfValues',level: 1}, 1);
                break;
            case 'BAR_SUM':     //command+b
                toolBar.handleMenuItemClick(event, {value: 'BarChartOfSums',level: 1}, 1);
                break;
            case 'BAR_MEAN':     //command+b
                toolBar.handleMenuItemClick(event, {value: 'BarChartOfMeans',level: 1}, 1);
                break;
            case 'BAR_STRETCHED':     //command+b
                toolBar.handleMenuItemClick(event, {value: 'StretchedBar',level: 1}, 1);
                break;
            case 'HISTOGRAM':   // h+f
                toolBar.handleMenuItemClick(event, {value: 'FreqHistogram',level: 1}, 1);
                break;
            case 'HISTOGRAM_PROPORTION':   // h+r
                toolBar.handleMenuItemClick(event, {value: 'PropHistogram',level: 1}, 1);
                break;
            case 'HISTOGRAM_PERCENTAGE':   // h+p
                toolBar.handleMenuItemClick(event, {value: 'PercHistogram',level: 1}, 1);
                break;
            case 'BOX':         //command+x
                toolBar.handleMenuItemClick(event, {value: 'Box',level: 1}, 1);
                break;
            case 'BOX_OUTLIER': //command+x+o
                toolBar.handleMenuItemClick(event, {value: 'BoxAndOutlier',level: 1}, 1);
                break;
            case 'BOX_DOT':     //x+d
                toolBar.handleMenuItemClick(event, {value: 'BoxAndDot',level: 1}, 1);
                break;
            case 'MAP':     //command + m
                toolBar.handleMenuItemClick(event, {value: 'Map',level: 1}, 1);
                break;
            case 'MEAN':    //command+shift+m
                toolBar.handleMenuItemClick(event, {value: 'Mean',level: 2}, 2);
                break;
            case 'MEDIAN':  //command+shift+d
                toolBar.handleMenuItemClick(event, {value: 'Median',level: 2}, 2);
                break;
            case 'MODE':  //command+shift+d
                toolBar.handleMenuItemClick(event, {value: 'Mode',level: 2}, 2);
                break;
            case 'MEAN_MODE_DEVIATION':   //command+shift+a
                toolBar.handleMenuItemClick(event, {value: 'MeanAvDev',level: 2}, 2);
                break;
            case 'VARIANCE':
                toolBar.handleMenuItemClick(event, {value: 'Variance',level: 2}, 2);
                break;
            case 'STD_DEVIATION':
                toolBar.handleMenuItemClick(event, {value: 'StDev',level: 2}, 2);
                break;
            case 'IQR':
                toolBar.handleMenuItemClick(event, {value: 'IQR',level: 2}, 2);
                break;
            case 'STD_ERROR':
                toolBar.handleMenuItemClick(event, {value: 'StdError',level: 2}, 2);
                break;
            case 'LABEL_TOGGLE': //command + ctrl + l
                Dyn.preferences.toggleStatsLabel();
                break;
            case 'DIVIDERS':    // command+ctrl+p
                toolBar.handleMenuItemClick(event, {value: 'Dividers',level: 2}, 2);
                break
            case 'CLEAR_REFERENCE_LINE':    // command+\
                toolBar.handleMenuItemClick(event, {value: 'clearAllRefLines',level: 1}, 2);
                break
            case 'LEAST_SQUARES_LINE': // command+ctrl+u
                toolBar.handleMenuItemClick(event, {value: 'LeastSqByAttribute',level: 3}, 2);
                break;
            case 'SHOW_SQUARES': // command+ctrl+w
                toolBar.handleMenuItemClick(event, {value: 'ShowHideSquaresOnLines',level: 3}, 2);
                break;
            case 'CLEAR_ALL_ANNOTATIONS': // command+a
                toolBar.handleMenuItemClick(event, {value: 'clearAllAnnotations',level: 1}, 2);
                break;
            case 'RESET_FILTER':    //command+f
                toolBar.handleMenuItemClick(event, {value: 'resetAllFilter',level: 2}, 2);
                break;
            case 'EXCLUDE_SELECTED':    //command+shift+x
                toolBar.handleMenuItemClick(event, {value: 'excludeSelected'}, 2);
                break;
            case 'KEEP_SELECTED':       // command+shift+y
                toolBar.handleMenuItemClick(event, {value: 'keepSelected'}, 2);
                break;
            case 'HELP':    //command + i
                toolBar.handleMenuItemClick(event, {value: 'SupportGuide'}, 1);
                break;
            case 'MODEL_PANEL': //ctrl + command + m
                toolBar.handleMenuItemClick(event, {value: 'modelFunction',level: 2}, 2);
                break;
            case 'SAMPLE_PANEL':    //ctrl + command + s
                toolBar.handleMenuItemClick(event, {value: 'randomSample', level: 1}, 1);
                break;
            case 'SCREENSHOT':      //command + p
                // toolBar.handleMenuItemClick(event, {value: 'ImagePNG', level: 1}, 1);
                event.preventDefault();
                event.stopPropagation();
                this.setState({showImageCapture: true});
                break;
            case 'SETTINGS_PANEL':  //ctrl + command + e
                toolBar.handleMenuItemClick(event, {value:'PlotSettings', level: 1}, 1);
                break;
            case 'ACCESSIBILITY_PANEL': //ctrl + command + a
                toolBar.handleMenuItemClick(event, {value: 'AccessibilitySettings', level: 1}, 1);
                break;
            case 'KEYBOARD_SHORTCUT': //ctrl + command + a
                toolBar.handleMenuItemClick(event, {value: 'KeyboardShortcuts', level: 1}, 1);
                break;
            case 'DATASET_SUMMARY':  //ctrl + command + .
                caseCard.setFocus('SUMMARY');
                break;
            case 'ADD_NEW_ATTRIBUTE_PANEL': //ctrl + command + n
                caseCard.openCard('ATTRIBUTE_ADD');
                break;
            case 'PLOT_SUMMARY': //ctrl + command + ,
                // summaryView.refs.plotSummary.focus();
                this.refs.plotContainer.focus();
                break;
            case 'ACCESSIBILITY_SUPPORT':   //command + ctrl + k
                Dyn.preferences.toggleAttributeContextMenu();
                caseCard.forceUpdate();
                break;
            case 'COUNT_FOCUS': //option + n
                toolBar.openMenuGroup('numberpercentage');
                break;
            case 'MODEL_FOCUS':
                toolBar.openMenuGroup('models');
                break;
            case 'STATS_FOCUS':     //option + s
                toolBar.openMenuGroup('stats');
                break;
            case 'REF_LINES_FOCUS': //option + l
                toolBar.openMenuGroup('lines');
                break;
            case 'FILTER_FOCUS':    //option + f
                toolBar.openMenuGroup('filterOptions');
                break;
            case 'ANNOTATION_FOCUS':
                toolBar.openMenuGroup('annotate');
                break;
            case 'HELP_FOCUS':  //option + i
                toolBar.openMenuGroup('help');
                break;
            case 'TITLE_FOCUS':     //command + shift + t
                Dyn.plotView.topMargin.setFocus();
                break;
            case 'X_FOCUS':     // command + shift + x
                Dyn.plotView.xAxis.setFocus();
                break;
            case 'Y_FOCUS':    // command + shift + y
                Dyn.plotView.yAxis.setFocus();
                break;
            case 'LEGEND_FOCUS':    // command + shift + c
                Dyn.plotView.rightMargin.setFocus();
                break;
        }
    }

    getChildContext() {
        return { shortcuts: shortcutManager }
    }

    // To initialize the plot environment
    initDataPlot = () => {
        let Dyn = this.Dyn;
        // To clean the subscribers used inside Dyn library
        Dyn.cleanMeditorSubscribers();

        // To set case card width
        this.fixLeftPanelWidth();

        // To switch theme
        this.switchTheme(this.state.theme || this.Dyn.preferences.getTheme());
        // Set mode
        Dyn.preferences.setMode(this.state.mode);
        this.setViewOnly(this.state.conf.viewOnly);
        // Don't go for data plot when no columnIds are present
        if(!(this.props.columnIds && this.props.columnIds.length >= 0)) {
            return;
        }

        // preprocessing, to update columnIds, columnNames, rowData
        // based on metadata, if metadata has derived attributes
        if (this.props.metaData && this.props.metaData['fields']) {
            this.props.metaData['fields'].forEach((attrib, index) => {
                if (attrib.hasOwnProperty("attribute_type") && attrib["attribute_type"] == 'derived'
                && ! this.props.columnIds.includes( attrib["id"])) {
                    // Ids and Names
                    this.props.columnIds.push(attrib["id"]);
                    this.props.columnNames.push(attrib["name"]);
                    // placeholder item in rowData
                    this.props.rowData.forEach((value, index) => {
                        value.push("");
                    });
                }
                // if name doesn't match use the one from metadata
                if (this.props.columnNames[index] !== attrib["name"] ) {
                    this.props.columnNames[index] = attrib["name"];
                }
            });
        }

        // Initializing Dataset
        this.dynDataset = new Dyn.DataSet(
            this.props.title,
            this.props.columnIds,
            this.props.columnNames,
            this.props.rowData,
            this.props.metaData,
            this.props.dataSource,
            undefined,
            undefined, //this.props.i18n,
        );

        // restore saved preference settings
        // NOTE: both this.state and this.state.conf contain preferences fields; consider removing redundant fields. --CDM 2024-05-07
        Dyn.preferences.restore( this.state );

        // Load translater
        this.setLang(this.state.language);

        // Determine if we are in play view or plot view
        let isPlayView = this.state.mode === 'jr';
        if(isPlayView && this.state.plotview && Object.keys(this.state.plotview).length > 0) {
            // Set playview false when plotview.plotState is not present
            if(!this.state.plotview?.playState) {
                isPlayView = false;
            }
        }
        this._setPlotOrPlayView(isPlayView, this.state.plotview, true);
    }

    _setPlotOrPlayView = (isPlayView = false, plotState = null, isInitialization = false) => {
        this.setState({ isPlayViewOn: isPlayView }, () => {
            const Dyn = this.Dyn;
            let isViewExist = false;
            // Destroy views when isInitialization is true
            if(isInitialization) {
                this.dynPlotView?.destroy();
                this.dynPlotView = null;
                this.dynElemPlayContainer?.destroy();
                this.dynElemPlayContainer = null;
            }
            if(isPlayView) {
                // destroy if plot view container already exists
                if(this.dynElemPlayContainer) {
                    isViewExist = true;
                } else {
                    this.dynElemPlayContainer = new ElemPlayContainer( Dyn, this.dynDataset, jQuery(this.elemPlayContainer) , (data) => {
                        // Force update to refresh header and group by component based on play container state and options
                        this.forceUpdate();
                    });
                }
            } else {
                // destroy if ploview already exists
                if(this.dynPlotView) {
                    isViewExist = true
                } else {
                    //TODO: construct plot view, destroy play container
                    this.dynPlotView = new this.Dyn.PlotView(
                        this.dynDataset,
                        jQuery(this.refs.plotContainer)
                    );
                }
            }

            // Calling plotview init after timeout to let react render plotview area
            // So that plotview can get correct value for height and width
            setTimeout(() => {
                // commenting - this.plotState || this.metaData
                // we don't need to pass metadata as param
                if(isPlayView) {
                    if(isViewExist) {
                        if(plotState) {
                            this.dynElemPlayContainer.restoreFromPlotState( plotState );
                        }
                    } else {
                        this.dynElemPlayContainer.initVisuals({
                            cardAreaWidth: this.state.reduceCaseCardWidth? Constants.PLAY_CARD_REDUCED : Constants.PLAY_CARD_WIDTH,
                            cardPlayBorder: 10,
                            bottomToolbarHeight: 80 },
                            plotState );
                    }
                    this.dynPlotView?.destroy(); // remove SVG view; notify others
                    this.dynPlotView = null;
                } else {
                    Dyn.plotUtil.setThemeColors( Dyn.preferences.getTheme() );
                    if(isViewExist) {
                        if(plotState) {
                            this.dynPlotView.restore(plotState, {isReloadablePlotState:isInitialization});
                        }
                    } else {
                        // Check is there any orphaned SVG element in plotContainer and remove it
                        this.refs.plotContainer.querySelectorAll('svg').forEach(element => {
                            element.remove();
                        });
                        // Init new view
                        this.dynPlotView.init(plotState, {isReloadablePlotState:isInitialization});
                    }
                    this.dynElemPlayContainer?.destroy(); // remove SVG view; notify others
                    this.dynElemPlayContainer = null;
                }
                this.dynDataset.initPostVisual();
                this.refreshColumnsForToolbar();

                // Restore card view
                if(plotState?.cardview?.activecard) {
                    let caseCard = this.refs.caseCardComponent;
                    caseCard.restore(this.props.plotState.cardview);
                }

                if(isInitialization) {
                    // Trigger onReady event after environment is initialized
                    if(this.props.onReady) {
                        this.props.onReady();
                    }
                }
            });
        });
    }

    // Callback for attribute add/edit close
    onClosingAttribEdit = () => {
        this.refreshColumnsForToolbar();
    }

    // TODO Do this process either inside dataSet.js or ToolbarComponent.jsx
    // Populate header object for toolbar
    refreshColumnsForToolbar = () => {
        let Dyn = this.Dyn;
        // For the dom-repeat in filter by
        var columns = [];
        if(Dyn.dataSet.columnIds) {
            Dyn.dataSet.columnIds.forEach((value, index) => {
                columns.push({
                    'id': value,
                    'name': Dyn.dataSet.columnNames[index]
                })
            });
        }
        this.setState({
            columns: columns
        });
    }

    componentDidMount = () => {
        // set values based on settings passed in conf object
        // animation
        let Dyn = this.Dyn;
        if ( typeof this.props.conf.animation === 'boolean' ){
            this.setAnimation( this.props.conf.animation );
        }
        if ( typeof this.state.conf.displayAttributeSetting === 'boolean' ){
            this.setDisplayAttributeSetting( this.state.conf.displayAttributeSetting );
        }
        if ( typeof this.state.conf.plotTitle === 'boolean' ){
            this.setPlotTitleVisible( this.state.conf.plotTitle );
        }
        if ( typeof this.state.conf.customAttribute === 'boolean'){
            this.setCustomAttribute( this.state.conf.customAttribute );
        }
        if (typeof this.props.conf.attributeContextMenu === 'boolean' ){
            this.setAttributeKeyboardSupport( this.props.conf.attributeContextMenu );
        }

        // Listeners to update case card view
        this.setupListenerForCaseCard();
        this.setupCommonListeners();

        // Listeners to update the table view
        this.setupListenerForCaseTable();

        // To initialize dataplot
        this.initDataPlot();

        // On browser window resized
        window.addEventListener("resize", this.onWindowResize);
        window.addEventListener("paste", this.onWindowPaste);

        // Restore table view from plotstate
        if(this.props.plotState?.tableview?.activetab) {
            this._toggleTableView(this.props.plotState.tableview.activetab);
            // Restore full table view
            if(this.props.plotState.tableview.fullView) {
                this.state.fullTableView = 1;
            }
        } else if(this.props.editable && this.props.columnIds && this.props.columnIds.length <= 1) {
            // Open table view by default when editable mode is true and columns are empty or it has only case column
            this._toggleTableView();
        }
    }

    /** respond to document Edit:Paste command (when there is no local selected element to handle the paste) */
    onWindowPaste = (event) => {
        // check for an image to paste
        let imageClipboardType = "",
            imageFileBlob = null;
        if( event.clipboardData?.items.length > 0 ) {
            let clipboardItems = event.clipboardData.items;
            for( let item of clipboardItems ) {
                if( item.type.indexOf( "image" ) === 0 ) {
                    imageClipboardType = item.type;
                    imageFileBlob = item.getAsFile();
                    break;
                }
            }
        }

        if( imageFileBlob ) {
            // if we have a plot object that can handle an image paste, call handler
            let plotElement = this.dynPlotView.plotShaper.findElement( this.Dyn.EPlotControl.kControlsAnnotateImage),
            imagePasteHandler = plotElement?.getPasteHandler( imageClipboardType );
            if( imagePasteHandler ) {
                let reader = new FileReader();
                reader.onload = function(event) {
                    imagePasteHandler( event.target.result ); // paste in "src" for image
                };
                reader.readAsDataURL(imageFileBlob);
                event.preventDefault();
            }
        } else if( this.dynPlotView?.hasKeyboardFocus( document.activeElement )) {
            // if the plot view background or element has the keyboard focus, do custom paste for copy/paste of annotations
            this.refs.toolBar.handleMenuItemClick( event, { value: 'paste' } );
        }
        // else let default paste handlers do their job
    }

    onWindowResize = () => {
        let mediator = this.Dyn.mediator;
        // Clear timeout
        if(this.windowResizeTimeout) {
            clearTimeout(this.windowResizeTimeout);
        }

        this.windowResizeTimeout = setTimeout(() => {
            // Publish plot:containerResized only when leftpanel width is not changed
            if(!this.fixLeftPanelWidth()) {
                // Refresh plot view
                mediator.publish( "plot:containerResized", {
                    container: jQuery(this.refs.plotContainer),
                    cardAreaWidth: this.state.reduceCaseCardWidth? Constants.PLAY_CARD_REDUCED : Constants.PLAY_CARD_WIDTH
                });
            }
        }, 300);
    }

    fixLeftPanelWidth = () => {
        const reduceCaseCardWidth = this.chartAreaDiv?.clientWidth <= 870;
        if(reduceCaseCardWidth != this.state.reduceCaseCardWidth) {
            this.setState({
                reduceCaseCardWidth
            }, () => {
                // To make sure the plot area is properly resized
                this.onWindowResize();
            });
            return true;
        }
        return false;
    }

    getVersion = () => {
        return ABOUT.version;
    }

    getText = (text) => {
        let Dyn = this.Dyn;
        if(Dyn.dataSet) {
            return Dyn.loc( text );
        } else {
            return text;
        }
    }

    setLang = (lang) => {
        let Dyn = this.Dyn,
            data = Dyn.locUtil.keysToLowerCase( locale[lang], lang ),
            i18n = (data && lang)? new Jed(data): null;
        // To set the current language's i18n object to visualization library
        this.dynDataset.gettextCatalog = i18n;
        Dyn.locUtil.unitTestHasRun || Dyn.locUtil.unitTest(locale);
    }

    switchLanguage = (lang) => {
        if(lang == this.state.language) {
            return;
        }

        this.setLang(lang);
        if(this.dynPlotView) {
            this.dynPlotView.refresh({ action:'switchLanguage' });
        }
        if(this.dynElemPlayContainer) {
            this.dynElemPlayContainer.updateVisuals({ action:'switchLanguage' });
        }
        this.setState({
            language: lang,
            ignoreInitPlot: true
        }, () => {
            // Force refresh toolbar after language change
            // to collapse the overflowing menu's
            this.refs.toolBar.forceRefreshToolbar();
        });
    }

    _handleDragStart = (e) => {
    }

    _handleDragEnd = (endSize) => {
        this.setState({
            resizerSize: endSize
        });
        this.onWindowResize();
    }

    // To open/close table view and switch between table, summary view
    _toggleTableView = (viewName) => {

        if (viewName){
            if (viewName === Constants.SUMMARY_VIEW){
                this.refs.summaryView.focus();
            } else {
                this.refs.tableView.focus();
            }
        }

        // To disable toggle when user clicks on a selected tab again
        if(this.state.resizerSize>Constants.TABLE_HEADER_HEIGHT && viewName === this.state.activeTableView) {
            this._toggleTableView()
            return;
        }
        var tableViewSize = Constants.TABLE_HEADER_HEIGHT,
            isViewResized = false;
        if(this.state.resizerSize === tableViewSize) {
            tableViewSize = Constants.TABLE_DEFAULT_OPENING_HEIGHT;
        } else if(viewName) {
            tableViewSize = this.state.resizerSize;
        }
        isViewResized = tableViewSize !== this.state.resizerSize;

        this.setState({
            resizerSize: tableViewSize,
            activeTableView: viewName || this.state.activeTableView
        });

        if(isViewResized) {
            this.onWindowResize();
        }
    }

    getRawData = () => {
        return this.caseTableComponent.getRawData();
    }

    getColumnIds = () => {
        return this.Dyn.dataSet.columnIds;
    }

    getColumnNames = () => {
        return this.Dyn.dataSet.columnNames;
    }

    // Inspired by the function onCellChange in CaseTableComponent.
    // Convert given rows arry of [row, colmun, oldvalue, newvalue]
    // and then pass it to Dyn.dataSet.updateCaseTableValues
    appendRawData = (rows) => {
        if(rows?.length > 0 && this.Dyn.dataSet.attribs.length > 0) {
            // Get case column's case length as maximum rows
            let existingNoOfRows = this.Dyn.dataSet.attribs[0].cases.length + 1;
            const changes = [];
            rows.forEach(function(rowData, index){
                const rowNo = existingNoOfRows + index;
                rowData.forEach(function(data, index){
                    const columnNo = index + 1;
                    changes.push([rowNo, columnNo, null, data]);
                });
            });
            this.Dyn.dataSet.updateCaseTableValues( changes, true /* firstTableRowIsAttributeName */ );
        }
    }

    // This function can be called from the place where the TuvaDataTools is intialized
    // to get the active metedata specific objects
    // ( The returned JSON can be passed back to TuvaDataTools to rerender metadata change )
    getMetaData = () => {
        return this.dynDataset.metaData;
    }

    getPlotState = () => {
        let Dyn = this.Dyn;
        var plotstate = {
                plotview: Dyn.plotView?.save() // save the plot view
                    || this.dynElemPlayContainer?.savePlotState(), // or the play view equivalent
                version: 2,
                conf: Dyn.preferences.save()
            };
        // To set toolbar
        if(Object.keys(this.state.toolbar || {}).length > 0) {
            plotstate.toolbar = this.state.toolbar;
        }

        // To set language
        if(this.state.language && this.state.language !== 'en-US') {
            plotstate.conf.language = this.state.language;
        }
        Dyn.assert( plotstate.conf.mode === this.state.mode );

        // Get table view state
        // TODO: Remove the second condition once save/restore support is added for sampling
        if(this.state.resizerSize > Constants.TABLE_HEADER_HEIGHT && this.state.activeTableView !== Constants.SAMPLE_STAT_VIEW){
            plotstate.tableview = {
                activetab: this.state.activeTableView
            }
            // Save full table view state
            if(this.state.fullTableView) {
                plotstate.tableview.fullView = true;
            }
        }

        // Get card view state
        const cardview = this.refs.caseCardComponent.save();
        if(cardview) {
            plotstate.cardview = cardview;
        }

        return plotstate;
    }

    // Function to get canvas version of current plotview
    // Callback function has to be passed as first argument to get the canvas back.
    // Example: tuvaDataTools.actions.getPlotPreview(function(canvas){console.log(canvas.toDataURL("image/png"))})
    getPlotPreview = (cb) => {
        if(this.dynElemPlayContainer) {
            captureElemPlayView(this.elemPlayContainer, cb);
        } else {
            this.refs.toolBar.convertPlotArea2Canvas(cb);
        }
    }

    resetPlot = () => {
        this.Dyn.plotView.mixUp();
    }

    // onPlotSave = () => {
    //     this.props.onPlotSave(this.getPlotState());
    // }

    setupCommonListeners = () => {
        // When the random sample is taken, or reset, update the flag
        // to follow whats the currne mode.
        let mediator = this.Dyn.mediator;
        mediator.subscribe( "records:randomSamplesUpdated" , (args) => {
            this.setState( {
                sampleMode:{
                        isSampleMode: Boolean(args.sampleSets.length > 0),
                        selectedView: args.selectedView
                    }
                });
        });

        mediator.subscribe( "toolBar:showKeyboardShortcuts" , (args) => {
            this.setState({ showKeyboardShortcuts: true});
        });
    };

    // For case card
    setupListenerForCaseCard = () => {
        let mediator = this.Dyn.mediator;
        let caseCard = this.refs.caseCardComponent;
        mediator.subscribe( "records:initialized", (args) => {
            caseCard.setBaseCase();
        });
        // Refresh case card after plot state is restored to reflect attribute name changes
        mediator.subscribe( "records:plotStateRestored", (args) => {
            caseCard.setBaseCase();
        });
        mediator.subscribe( "records:setSelectedAttribute", (data) => {
            caseCard.setSelectedAttribute(data);
        });
        mediator.subscribe( "records:setAddedAttribute", (data) => {
            caseCard.setAddedAttribute(data);
        });
        mediator.subscribe( "records:setRemovedAttribute", (data) => {
            caseCard.setRemovedAttribute(data);
        });
        mediator.subscribe( "records:setAttributeValues", (data) => {
            caseCard.setAttributeValues(data);
        });
        mediator.subscribe( "records:setAttributeMetadata", (data) => {
            caseCard.setAttributeMetadata(data);
        });
        // TODO: Set callback instead of handling it through events
        mediator.subscribe( "card:reinstateCaseCard", (data) => {
            caseCard.reinstateCaseCard(true);
        });
        mediator.subscribe( "records:setCasesFiltered", (data) => {
            caseCard.setCasesFiltered(data);
        });
        mediator.subscribe( "records:setCasesSelected", (data) => {
            caseCard.setCasesSelected(data);
        });
        mediator.subscribe( "toolBar:filterByAttribute", (data) => {
            caseCard.addOrEditAttribute({id:data.attributeId});
        });
        mediator.subscribe( "toolBar:openModelFunctions", (data) => {
            caseCard.openModelFunctions();
        });
        mediator.subscribe( "toolBar:openPlotSettings", (data) => {
            caseCard.openPlotSettings();
        });
        mediator.subscribe( "toolBar:openAccessibilitySettings", (data) => {
            caseCard.openAccessibilitySettings();
        });
        // mediator.subscribe( "toolBar:openStyleSettings", (data) => {
        //     caseCard.openStyleSettings();
        // });
        mediator.subscribe( "toolBar:randomSample", (data) => {
            caseCard.openRandomSample();
        });
        mediator.subscribe( "toolBar:modelFunction", (data) => {
            caseCard.openModelFunctions();
        });
        // When filtered values are reset
        mediator.subscribe( "records:caseFilterByAttribute", (data) => {
            caseCard.removeCasesFiltered(data);
        });
        // To reinitiate the case card if it is in open state
        mediator.subscribe( "toolBar:closeCurrentAttributeFilter", (data) => {
            caseCard.reinstateCaseCard();
        });
        // To close the Model Functions panel if it is in open state
        mediator.subscribe( "toolBar:closeModelFunctions", (data) => {
            caseCard.closeModelFunctions();
        });
        // To close the style settings panel if it is in open state
        // mediator.subscribe( "toolBar:closeStyleSettings", (data) => {
        //     caseCard.closeStyleSettings();
        // });
        // To close the Random Sampler panel if it is in open state
        mediator.subscribe( "toolBar:closeRandomSample", (data) => {
            caseCard.closeRandomSample();
        });
        mediator.subscribe( "pref:newColorScheme", (data) => {
            caseCard.setColorSchema();
        });
    }

    onAttributeCaseFilter = (args) => {
        let mediator = this.Dyn.mediator;
        // To let dataSet.js know about filtered records
        mediator.publish( "records:caseFilterByAttribute", args );
    }

    onAttributeNumericIntervalsUpdated = (args) => {
        let mediator = this.Dyn.mediator;
        mediator.publish( "records:attributeNumericIntervalsUpdated", args );
    }

    onAttributeNumericDecimalsUpdated = (args) => {
        let mediator = this.Dyn.mediator;
        mediator.publish( "records:attributeNumericDecimalsUpdated", args );
    }

    onAttributeDataTypeChange = (args) => {
        let mediator = this.Dyn.mediator;
        // To let dataSet.js know about datatype change of an attribute
        mediator.publish( "records:attributeDatatypeUpdated", args);
    }

    onAttributeSortOrderChange = (args) => {
        let mediator = this.Dyn.mediator;
        //pass message to plot on the update of the datatype for attribute
        mediator.publish( "records:attributeSortOrderUpdated", args);
    }

    onAttributeCasesSelected = (indexes) => {
        let mediator = this.Dyn.mediator;
        // Let others know of the record change.
        mediator.publish("records:casesSelected", {
            ids: indexes,
            object: "cards"
        });
    }

    onAttributeNameSelected = (attr) => {
        let Dyn = this.Dyn;
        let mediator = this.Dyn.mediator;
        var attributeData = {
            id: attr.id,
            name: attr.columnName,
            object: "cards"
        };
        Dyn.time( 'onAttributeNameSelected', 'Start' );
        // Call the method to notify others that attribute is selected.
        mediator.publish( "records:attributeNameSelected", attributeData );
        Dyn.time( 'onAttributeNameSelected', 'End' );
    }

    onOrderByAttributeSelected = (attr) => {
        let Dyn = this.Dyn;
        // reusing the orderbyAttribute message publish from toolBar
        Dyn.time( 'onOrderByAttributeSelected', 'Start' );
        // Call the method to notify others that attribute is selected.
        Dyn.mediator.publish( "toolBar:orderByAttribute", attr );
        Dyn.time( 'onOrderByAttributeSelected', 'End' );
    }

    addRemoveAttributeOnAxis = (attr, axis, action) => {
        let Dyn = this.Dyn;
        var obj = {
            'attrID': attr.id,
            'axis': axis,
            'action': action
        };
        Dyn.time( 'addRemoveAttributeOnAxis', 'Start' );
        // Call the method to ask plotview to drop attribute on axis
        Dyn.mediator.publish("plot:addRemoveAttributeOnAxis", obj );
        Dyn.time( 'addRemoveAttributeOnAxis', 'End' );
    }

    // For case table
    setupListenerForCaseTable = () => {
        let mediator = this.Dyn.mediator;
        let caseTable = this.caseTableComponent;
        //listen to record object, once its initialized set the grid
        mediator.subscribe( "records:initialized", (args) => {
            caseTable.initEditMode();
            caseTable.setBaseTable();
        });

        // Refresh table view on formula, name/description, or edit table update
        mediator.subscribe( "records:setAttributeValues", (args) => {
            caseTable.setBaseTable();
        });
        // Refresh table view on attribute setting update (e.g. change in numeric decimals)
        mediator.subscribe( "records:setAttributeMetadata", (args) => {
            caseTable.setBaseTable();
        });
        mediator.subscribe( "records:randomSamplesUpdated", (args) => {
            //let updateHints = { casesChanged:args.attributeCasesChanged, namesChanged:args.attributeNamesChanged };
            caseTable.setBaseTable(); // caseTable.setBaseTable( updateHints ) for efficiency?
        });

        // Refresh table view after plot state is restored to reflect attribute name changes
        mediator.subscribe( "records:plotStateRestored", (args) => {
            caseTable.setBaseTable();
        });

        // user clicks on cases(records) on plot or cardView
        mediator.subscribe( "records:setCasesSelected", (args) => {
            this.caseTableComponent.setSelectedRowIds( args );
        });
        mediator.subscribe( "records:setCasesSelectedEnd", (args) => {
            this.caseTableComponent.setSelectedRowIds( args );
        });

        mediator.subscribe( "records:setCasesFiltered", (data) => {
            caseTable.handleFilterChange(data);
        });

        mediator.subscribe( "records:randomSamplesUpdated", (args) => {
            //show stat summary, or hide it
            if( args.sampleSets.length > 0 ) {
                this.refs.SampleStatsTab.style.display = 'inline-block';
                if( args.isGenerate ) {
                    //show stat summary if it is not active
                    if( this.state.resizerSize === Constants.TABLE_HEADER_HEIGHT || this.state.activeTableView !== Constants.SAMPLE_STAT_VIEW ){
                        this._toggleTableView(Constants.SAMPLE_STAT_VIEW);
                    }
                }
            } else {
                this.refs.SampleStatsTab.style.display = 'none';
                if(this.state.activeTableView === Constants.SAMPLE_STAT_VIEW) {
                    // If the table view is opened
                    if(this.state.resizerSize !== Constants.TABLE_HEADER_HEIGHT) {
                        this._toggleTableView(Constants.TABLE_VIEW);
                    } else {
                        // Silently make table view is opened view
                        this.state.activeTableView = Constants.TABLE_VIEW;
                    }
                }
            }
        });
    }
    // Callback function to listen column select event on Case Table View
    onCaseTableColumnSelect = (column) => {
        let mediator = this.Dyn.mediator;
        var attributeData = {
            id: column.id,
            name: column.name,
            object: "table"
        };
        mediator.publish( "records:attributeNameSelected", attributeData );
    }
    // Callback function to listen row select event on Case Table View
    onCaseTableRowSelect = (ids) => {
        let mediator = this.Dyn.mediator;
        // To update the plotview on row selection
        var record = {
            ids: ids,
            object: "table",
            disableToggle: true
        };
        mediator.publish( "records:casesSelected", record );
    }

    // TODO Validate and remove this function if it is not required
    onCaseCardToggled = (isOpen) => {
        if(isOpen === undefined) {
            this.setState({
                openCaseCard: !this.state.openCaseCard
            });
        } else {
            this.setState({
                openCaseCard: isOpen
            });
        }
        this.onWindowResize();
    }
    // Listening caseCard attributes visibility settings change
    onCaseCardAttributesHidden = (hiddenAttributes) => {
        let mediator = this.Dyn.mediator;
        mediator.publish("records:updateAttributesDisplay", {
            "attributes": hiddenAttributes
        });
    }

    onApplyRandomSample = ( data ) => {
        let mediator = this.Dyn.mediator;
        mediator.publish( "records:generateRandomSamples", data );
    }

    onModelFunctionPanelVisibilityChange = (isVisible) => {
        let mediator = this.Dyn.mediator;
        mediator.publish( "records:modelFunctionVisibility", isVisible );
    }

    switchTheme = (themeName) => {
        let parnet = ReactDOM.findDOMNode(this);
        let Dyn = this.Dyn;
        const currentTheme = getColorContrastsByMode(Dyn.preferences.getTheme(), this.state.mode);
        if (currentTheme) {
            parnet.classList.remove('tde-theme-' + currentTheme);
        }
        Dyn.preferences.setTheme(themeName);
        parnet.classList.toggle('tde-theme-' + getColorContrastsByMode(themeName, this.state.mode));
    }

    setGridLines = (value) => {
        let Dyn = this.Dyn;
        Dyn.preferences.setGridLinesOn(value);
    }

    setDisplayAttributeSetting = (value) => {
        let Dyn = this.Dyn;
        let caseCard = this.refs.caseCardComponent;
        Dyn.preferences.setDisplayAttributeSettingOn(value);
        caseCard.forceUpdate();
    }

    setPlotTitleVisible = (value) => {
        let Dyn = this.Dyn;
        Dyn.preferences.setPlotTitleVisible(value);
    }

    setCustomAttribute = (value) => {
        let Dyn = this.Dyn;
        let caseCard = this.refs.caseCardComponent;
        Dyn.preferences.setCustomAttributeOn(value);
        caseCard.forceUpdate();
    }

    setStatsLabels = (value) => {
        let Dyn = this.Dyn;
        Dyn.preferences.setStatsLabelOn(value);
    }

    setAttributeKeyboardSupport = (value) => {
        let Dyn = this.Dyn;
        let caseCard = this.refs.caseCardComponent;
        Dyn.preferences.setAttributeContextMenu(value);
        caseCard.forceUpdate();
    }

    setAnimation = (value) => {
        let Dyn = this.Dyn;
        Dyn.preferences.setAnimationOn(value);
    }

    setViewOnly = (viewOnly) => {
        let Dyn = this.Dyn;
        Dyn.preferences.setViewOnly(viewOnly);
    }

    setFontSize = (value) => {
        let Dyn = this.Dyn;
        Dyn.preferences.setFontSizeMultiplier(value);
    }

    setCaseIconSize = (value) => {
        let Dyn = this.Dyn;
        Dyn.preferences.setCaseIconSize(value);
    }

    getDirtyRawData = () => {
        return this.caseTableComponent.getDirtyRawData();
    }

    // To return consolidated conf
    static fixPropsConf = (props) => {
        const metaConf = props.metaData?.conf || {};
        var conf = Object.assign(metaConf, props.options);
        if(props.language) {
            conf.language = props.language;
        }
        if(props.mode) {
            conf.mode = props.mode;
        }
        conf = Object.assign(conf, props.conf);
        return conf;
    }

    static getDerivedStateFromProps = (props, state) => {
        // Fixing plotstate
        let plotState = props.plotState? PlotStateUtil.fixPlotState(props.plotState) : {}
        // Fixing conf
        let propConf = TuvaDataTool.fixPropsConf(props);
        // Consolidating options from props and plotState(takes priority)
        let conf = Object.assign(propConf, plotState.conf);

        let isLanguageChangedViaProps = false;
        if(state.lastConfLanguage !== props.language) {
            isLanguageChangedViaProps = true;
            conf.language = props.language;
            state.lastConfLanguage = conf.language;
            state.language = conf.language;
        }

        let isThemeChangedViaProps = false;
        if(state.lastConfTheme !== props.conf.theme) {
            isThemeChangedViaProps = true;
            conf.theme = props.conf.theme;
            state.lastConfTheme = conf.theme;
            state.theme = conf.theme;
        }

        let isViewOnlyChangedViaProps = false;
        if(state.lastConfViewOnly !== props.conf.viewOnly) {
            isViewOnlyChangedViaProps = true;
            conf.viewOnly = props.conf.viewOnly;
            state.lastConfViewOnly = conf.viewOnly;
        }

        let animation = (conf.animation !== 'off' && conf.animation !== false );
        let fontSizeMultiplier = conf.fontSizeMultiplier;
        // To refresh plot
        // Change to support authoring tool and avoid refreshing the plotview
        if(!state.ignoreInitPlot && (state.columnIds != props.columnIds
            // || (state.mode && state.mode != props.mode)
            // Following 4 options from conf
            || isLanguageChangedViaProps
            || isThemeChangedViaProps
            || isViewOnlyChangedViaProps
            // || state.theme != conf.theme
            || state.animation != animation
            || state.fontSizeMultiplier != fontSizeMultiplier
            || (plotState.plotview && (JSON.stringify(plotState.plotview) != JSON.stringify(state.plotview))))) {
            state.refreshPlot = true;
        } else {
            state.refreshPlot = false;
            state.ignoreInitPlot = false;
        }

        // Adding plotview state
        state.plotview = plotState.plotview || undefined;

        // Adding toolbar state
        state.toolbar = plotState.toolbar || props.toolbar || undefined;

        // Adding language state
        state.language = state.language || conf.language || 'en-US';
        state.theme = conf.theme;
        state.animation = animation;
        state.wantY2Axis = conf.wantY2Axis;
        state.fontSizeMultiplier = fontSizeMultiplier;

        // Adding mode state
        state.mode = conf.mode || undefined;

        // Setting these properties into state only to detect whether plotview require refresh or not
        // This is used to determine value for a variable state.refreshPlot
        state.columnIds = props.columnIds;
        // state.allowPlotStateSave = typeof props.onPlotSave === 'function';

        /* Setting consolidated conf to state.
         * TODO: Remove all config related properties from state object and use those from state.conf
         * Example: state.animation should be changed to state.conf.animation
         */
        state.conf = conf;

        return state;
    }

    componentDidUpdate = (prevProps) => {
        if(this.state.refreshPlot) {
            this.state.refreshPlot = false;
            this.initDataPlot();
        }

        // Open table view when editable mode is true
        if(prevProps.editable != this.props.editable) {
            this._toggleTableView();
        }
    }

    closeKeyboardShortcutsPopup = () => {
        this.setState({
            showKeyboardShortcuts : false
        })
    }

    openKeyboardShortcuts = () => {
        let mediator = this.Dyn.mediator;
        mediator.publish( "toolBar:showKeyboardShortcuts" );
    }

    _isTableViewOpened = () => {
        return this.state.resizerSize>Constants.TABLE_HEADER_HEIGHT;
    }

    _toggleTableFullView = () => {
        let fullTableView = this.state.fullTableView;
        if(fullTableView > 0) {
            if(fullTableView === 1) {
                // Collapse the table view
                this._toggleTableView();
            }
            fullTableView = 0; // Close full view
        } else if(this._isTableViewOpened()) {
            fullTableView = 2; // Open full view from already opened table view
        } else {
            fullTableView = 1; // Open full view from collapsed table view
            // Open the tableview
            this._toggleTableView();
        }
        this.setState({fullTableView: fullTableView});
    }

    _getVersionComponent = () => {
        return <a className="tde-version tde-text-color" target="_blank" href={'https://tuvalabs.com/changelogs/data-exploration/#v' + this.getVersion()}>v {this.getVersion()}</a>
    }

    // Render the UI of toolbar component
    render = () => {
        const _requireJrMode = requireJrMode(this.state.mode);
        const isTableViewOpened = this._isTableViewOpened();
        const activeTableView = isTableViewOpened? this.state.activeTableView: '';
        const viewOnly = this.Dyn.preferences.isViewOnly();
        const isDrawOnly = this.Dyn.plotUtil?.isDrawOnly();
        var hasSample = this.Dyn.dataSet && this.Dyn.dataSet.caseSampler.hasSamples();
        const activeTableViewLabel = this.state.activeTableView === Constants.SUMMARY_VIEW? 'Summary View': this.state.activeTableView === Constants.SAMPLE_STAT_VIEW? 'Sample Statistics': 'Table View';
        return (
            <Shortcuts name="TuvaDataTools" targetNodeSelector="body" className={'tde-shortcut-element'} isolate = {true} preventDefault = {true} stopPropagation = {true} handler={this._handleShortcuts}>
                <div className={'tde-wrapper tde-bg-color tde-text-color tde-fill'  + (this.isTouchDevice? '': ' no-touch') + (this.state.fullTableView > 0? ' tde-table-only': '') + (_requireJrMode? ' tde-elem-mode': '') + (isDrawOnly? ' tde-draw-only': '')} ref={ ele => {this.chartAreaDiv = ele;} } tabIndex="1">
                    <div className={"tde-left-panel tde-flexbox-allow-child-fill" + (this.state.reduceCaseCardWidth? ' tde-reduced-left-panel': '')} role="region">
                        <CaseCardComponent ref="caseCardComponent" mode={this.state.mode}
                            Dyn = {this.Dyn}
                            // dataType={'numerical'}
                            showHeader={true}
                            isOpen={this.state.openCaseCard}
                            toolsContainer={this.chartAreaDiv}
                            // disableAddNewAttr={!this.state.customAttribute}
                            // disableAttrDisplaySettings={!this.state.displayAttributeSetting}
                            draggingElementParent={this.chartAreaDiv}
                            onClosingAttribEdit={this.onClosingAttribEdit}
                            onAddAttrClick={this.props.onAddAttrClick}
                            onCaseCardToggled={this.onCaseCardToggled}
                            onAttributesHidden={this.onCaseCardAttributesHidden}
                            onAttributeCaseFilter={this.onAttributeCaseFilter}
                            onAttributeDataTypeChange={this.onAttributeDataTypeChange}
                            onAttributeNumericIntervalsUpdated={this.onAttributeNumericIntervalsUpdated}
                            onAttributeNumericDecimalsUpdated={this.onAttributeNumericDecimalsUpdated}
                            onAttributeSortOrderChange={this.onAttributeSortOrderChange}
                            onAttributeCasesSelected={this.onAttributeCasesSelected}
                            onAttributeNameSelected={this.onAttributeNameSelected}
                            onOrderByAttributeSelected={this.onOrderByAttributeSelected}
                            addRemoveAttributeOnAxis={this.addRemoveAttributeOnAxis}
                            onApplyRandomSample={this.onApplyRandomSample}
                            onModelFunctionVisibilityChange={this.onModelFunctionPanelVisibilityChange}
                            switchLanguage={this.switchLanguage}
                            language={this.state.language}
                            switchTheme={this.switchTheme}
                            reduceCaseCardWidth = {this.state.reduceCaseCardWidth}
                            />
                    </div>
                    <div className={"tde-right-panel tde-flexbox-allow-child-fill" + (_requireJrMode? '': ' tde-border-left')}>
                        <div className={"tde-fill " + (this.state.spacerClass || '')}>
                        {!viewOnly &&
                        <div ref="toolBarWrapper" className="tde-toolbar-panel tde-d-flex" role="region">
                            <ToolbarComponent columns={this.state.columns} language={this.state.language}
                                sampleMode={this.state.sampleMode}
                                Dyn = {this.Dyn}
                                mode={this.state.mode}
                                config={this.state.toolbar}
                                plotContainer = {this.refs.plotContainer}
                                toolsContainer={this.chartAreaDiv}
                                ref="toolBar"
                                switchTheme={this.switchTheme}
                                setFinalClass={cls => this.setState({spacerClass: cls})}
                                // allowPlotStateSave = {this.state.allowPlotStateSave}
                                switchLanguage={this.switchLanguage}
                                // onPlotSave={this.onPlotSave}
                                onCaptureImage={(e) => {
                                    if(e.target.getAttribute('role') === 'menuitem') {
                                        this.setState({showImageCapture: {sourceEle: e.target}})
                                    } else {
                                        this.setState({showImageCapture: true})}
                                    }
                                }
                                onPlayViewClick={() => {
                                    const plotState = this.dynPlotView.save();
                                    this._setPlotOrPlayView( true, plotState );
                                }}
                                />
                            {isDrawOnly && <div className="tde-align-center tde-d-flex tde-divider-bottom tde-px-2">{this._getVersionComponent()}</div>}
                        </div>
                        }
                        <div className={"tde-plotview-panel" + (viewOnly? " tde-fill":"")}>
                            <SplitPane split="horizontal" minSize={Constants.TABLE_HEADER_HEIGHT} primary="second"
                                defaultSize={Constants.TABLE_HEADER_HEIGHT}
                                size={isDrawOnly?0:this.state.resizerSize} maxSize={-200}
                                allowResize={!isDrawOnly}
                                onDragStarted={this._handleDragStart}
                                onDragFinished={this._handleDragEnd}>
                                <div className="tde-plotview-wrapper" ref="plotContainer" tabIndex="0" role="region" aria-describedby='plotSummary' aria-label="Plot Area">
                                <div id="plotSummary" ref="plotSummary" style={{ display: 'none' }}></div>
                                <PlotViewLoadingComponent Dyn={this.Dyn} />
                                </div>
                                <div className="tde-table-wrapper" role="region">
                                    <div className="tde-table-header">
                                        {this.state.fullTableView === 0 && <PlainButton onClick={() => {this._toggleTableView()}} aria-label={this.getText('Toggle Table View')}
                                            style={{display:'inline-block'}}>
                                            <i className="tde-i tde-i-next"
                                                style={{transform: 'rotate(' + (isTableViewOpened?'90':'270') + 'deg)'}}></i>
                                        </PlainButton>
                                        }
                                        <PlainButton className={'tde-s1 tde-font-weight-medium tde-cell' + (activeTableView===Constants.TABLE_VIEW?' tde-active':'')}
                                            onClick={() => {this._toggleTableView(Constants.TABLE_VIEW)}} ref="tableView"
                                            style={{display:'inline-block'}}
                                            aria-pressed={activeTableView===Constants.TABLE_VIEW}>
                                            {this.getText('Table View')}
                                        </PlainButton>
                                        <PlainButton className={'tde-s1 tde-font-weight-medium tde-cell' + (activeTableView===Constants.SUMMARY_VIEW?' tde-active':'')}
                                            onClick={() => {this._toggleTableView(Constants.SUMMARY_VIEW)}} ref="summaryView"
                                            style={{display:'inline-block'}}
                                            aria-pressed={activeTableView===Constants.SUMMARY_VIEW}>
                                            {this.getText('Summary View')}
                                        </PlainButton>
                                        <PlainButton className={'tde-s1 tde-font-weight-medium tde-cell' + (activeTableView===Constants.SAMPLE_STAT_VIEW?' tde-active':'')}
                                            onClick={() => {this._toggleTableView(Constants.SAMPLE_STAT_VIEW)}} ref="SampleStatsTab"
                                            style={{display:'none'}}
                                            aria-pressed={activeTableView===Constants.SAMPLE_STAT_VIEW}>
                                            {this.getText('Sample Statistics')}
                                        </PlainButton>
                                        { !this.props.isTuva &&
                                            <div className="tde-poweredby">
                                            <img title={'v ' + this.getVersion()} src="data:image/png;base64,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" alt="powered by Tuvalabs" />
                                            </div>
                                        }
                                        <div style={{display:'flex'}} className='tde-flex-items-center'>
                                            <ToolTip tip={this.getText(this.state.fullTableView? `Collapse ${activeTableViewLabel} to Previous Height` : `Expand ${activeTableViewLabel} to Full Height`)} Dyn={this.Dyn} dir={this.state.fullTableView? 'b' : 't'}>
                                                <PlainButton className="tde-mr-3" aria-label={this.getText(this.state.fullTableView? `Collapse ${activeTableViewLabel} to Previous Height` : `Expand ${activeTableViewLabel} to Full Height`)}
                                                    style={{fontSize: 24}}
                                                    onClick={this._toggleTableFullView}>
                                                    <span className={"tde-i " + (this.state.fullTableView? "tde-i-collapse": "tde-i-expand")}></span>
                                                </PlainButton>
                                            </ToolTip>
                                            {!viewOnly &&
                                            <ToolTip tip={this.getText('Keyboard Shortcuts')} Dyn={this.Dyn} dir={this.state.fullTableView? 'b' : 't'}>
                                                <PlainButton className="tde-mr-3" aria-label={this.getText('Keyboard Shortcuts')} onClick={this.openKeyboardShortcuts}><span className="tde-i tde-i-keyboard"></span></PlainButton>
                                            </ToolTip>
                                            }
                                            {this._getVersionComponent()}
                                        </div>
                                    </div><div className="tde-padding-table">
                                        <div style={{display: this.state.activeTableView===Constants.TABLE_VIEW?'block':'none'}} className={hasSample? 'tde-with-sample': ''}>
                                            <CaseTableComponent ref={ ele => { this.caseTableComponent = ele }}
                                                Dyn = {this.Dyn}
                                                wopiLink={this.props.wopiLink}
                                                editable={this.props.editable}
                                                onTableDataSave={this.props.onTableDataSave}
                                                tableViewHeight={this.state.resizerSize}
                                                fullTableView={this.state.fullTableView > 0}
                                                onColumnSelect={this.onCaseTableColumnSelect}
                                                onRowSelect={this.onCaseTableRowSelect}
                                                tableHeaderHeight={Constants.TABLE_HEADER_HEIGHT}
                                                isOpen={this.state.resizerSize>Constants.TABLE_HEADER_HEIGHT}
                                                isActive={this.state.activeTableView===Constants.TABLE_VIEW} />
                                        </div>
                                        <div style={{display: this.state.activeTableView===Constants.SUMMARY_VIEW?'block':'none'}}>
                                            <SummaryViewComponent ref="summaryViewComponent" lang={this.state.language} Dyn = {this.Dyn} />
                                        </div>
                                        <div style={{display: this.state.activeTableView===Constants.SAMPLE_STAT_VIEW?'block':'none'}}>
                                            <SampleStatsComponent Dyn={this.Dyn} />
                                        </div>
                                    </div>
                                </div>
                            </SplitPane>
                        </div>
                        {/* <canvas id="plotCanvas" style={{display:'none'}}></canvas> */}
                        </div>
                    </div>
                    {this.state.showKeyboardShortcuts && <KeyboardShortcutsPopup Dyn={this.Dyn} onClose={this.closeKeyboardShortcutsPopup} />}
                    {this.state.showImageCapture && <Screenshot getPlotPreview={this.getPlotPreview}
                        Dyn={this.Dyn}
                        plotContainer = {this.refs.plotContainer}
                        close={() => {
                            // Focus the screenshot menu back
                            if(typeof this.state.showImageCapture === 'object') {
                                this.state.showImageCapture.sourceEle.focus();
                            }
                            this.setState({showImageCapture: false});
                        }} />
                    }
                    {this.state.isPlayViewOn && (<ElemPlay Dyn={this.Dyn}
                        dynElemPlayContainer={this.dynElemPlayContainer}
                        reduceCaseCardWidth={this.state.reduceCaseCardWidth}
                        ref={ref => this.elemPlayContainer = ref}
                        onSwitchToPlotView={() => {
                            let result = this.dynElemPlayContainer.switchOutOfPlayView();
                            if (result.canSwitch) {
                                this._setPlotOrPlayView(false, result.plotState);
                            }
                        }}
                    />)}
                </div>
            </Shortcuts>
        )
    }
}


// To make TuvaDataTool component reference as private
let tuvaToolHolder = function(tool, tuvaDataTools) {
    let _tool = tool;
    return {
        changeTheme: (theme) => {
            _tool.switchTheme(theme);
        },
        setGridLines: (value) => {
            _tool.setGridLines(value);
        },
        setDisplayAttributeSetting: (value) => {
            _tool.setDisplayAttributeSetting(value);
        },
        setPlotTitleVisible: (value) => {
            _tool.setPlotTitleVisible(value);
        },
        setCustomAttribute: (value) => {
            _tool.setCustomAttribute(value);
        },
        setStatsLabels: (value) => {
            _tool.setStatsLabels(value);
        },
        setAttributeKeyboardSupport: (value) => {
            _tool.setAttributeKeyboardSupport(value);
        },
        setAnimation: (value) => {
            _tool.setAnimation(value);
        },
        setFontSize: (value) => {
            _tool.setFontSize(value);
        },
        setCaseSize: (value) => {
            _tool.setCaseIconSize(value);
        },
        resize: () => {
            _tool.onWindowResize();
        },
        getRawData: () => {
            return _tool.getRawData();
        },
        getColumnIds: () => {
            return _tool.getColumnIds();
        },
        getColumnNames: () => {
            return _tool.getColumnNames();
        },
        appendRawData: (rows) => {
            _tool.appendRawData(rows);
        },
        getMetaData: () => {
            return _tool.getMetaData();
        },
        getPlotState: () => {
            return _tool.getPlotState();
        },
        getPlotPreview: (cb) => {
            return _tool.getPlotPreview(cb);
        },
        resetPlot: () => {
            return _tool.resetPlot();
        },
        validatePlotState: (plotState) => {
            /*
             * Updating to latest plotsate version and validating agianst it.
             */
            var revisedPlotState = PlotStateUtil.fixPlotState(plotState);
            var v = new Validator();

            // TODO: spit out few warning console messages based on the results/errors
            return v.validate(revisedPlotState, plotStateSchema);
        },
        setPlotState: (plotState) => {
            tuvaDataTools.setState({
                plotState: plotState,
                ignorePropsPlotState: true
            });
            // _tool.setPlotState(plotState);
        },
        getDirtyRawData: () => {
            return _tool.getDirtyRawData();
        },
        destroy: () => {
            ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(tuvaDataTools).parentNode);
        }
    }
}

class TuvaDataTools extends React.Component {

    constructor(props) {
        super(props);
    }

    static getDerivedStateFromProps = (props, state) => {

        // Adding this to avoid overwriting state.plotState as initially its empty
        if (state.ignorePropsPlotState !== true)
        {
            state = Object.assign(state, props);
        }
        delete state.ignorePropsPlotState;
        return state;

    }

    state = {}

    render = () => {
        return (
            <TuvaDataTool {...this.state} ref={ref => this.actions = tuvaToolHolder(ref, this)}/>
        )
    }
}

TuvaDataTools.propTypes = {
    conf: PropTypes.shape({
        attributeContextMenu: PropTypes.bool,
        animation: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.string
        ]),
        gridLines: PropTypes.bool,
        displayAttributeSetting: PropTypes.bool,
        customAttribute: PropTypes.bool,
        statsLabel: PropTypes.bool,
        wantY2Axis: PropTypes.bool
    }),
    wopiLink: PropTypes.string
}

TuvaDataTools.defaultProps = {
    conf: {
        attributeContextMenu: false,
        animation: true,
        gridLines: false,
        displayAttributeSetting: true,
        customAttribute: true,
        statsLabel: false,
        wantY2Axis: false
    }
}

export default TuvaDataTools;
